import React from 'react'
import { Box, Paper, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import img from '../../../../assets/images/common/astro.png'
import { Link } from 'react-router-dom'
import { TruncateText } from '../../../../utils/TruncateText'


const MainBox = styled(Box)(({theme}) => ({
    margin: theme.spacing(0, 2),
    padding: theme.spacing(1, 0),
    display: 'flex',
    width: '46vw',
    height: '23vh',
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
      height: '20vh',
      margin: theme.spacing(1, 2),
      padding: theme.spacing(0),
    }
}))

const ImageBox = styled(Box)(({theme}) => ({
    display: 'flex',
    width: '20%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
}))

const LinkTypography = styled(Typography)(({theme}) => ({
    width: '100%',
    height: '15%',
    margin: theme.spacing(1, 0),
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
        width: '113%',
        height: '35%',
        fontSize: '0.7rem',
    }
}))

const DescTypography = styled(Typography)(({theme}) => ({
    width: '100%',
    height: '70%',
    display: 'flex',
    justifyContent: 'left',
    fontSize: '0.8rem',
    color: 'text.secondary',
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.6rem',
    }
}))

const TagsTypography = styled(Typography)(({theme}) => ({
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
    }
}))


function NewsCard({ image_url, title, link, description, pubDate, category }) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
    
    const textLength = isMobile ? 150 : 300;

    const truncatedDescription = TruncateText(description, textLength);

  return (
    <MainBox component={Paper} >
        <ImageBox component="img" src={image_url ? image_url : img}/>
        <Box sx={{ px: 2, width: '80%', height: '100%', display: 'flex', flexDirection: 'column', gap: 1, }} >
            <LinkTypography fontWeight={600} fontFamily={'sans-serif'}>
                <Link to={link} target='_blank' style={{ textDecoration: 'none' }} >{title}</Link>
            </LinkTypography>
            <DescTypography fontFamily={'sans-serif'} sx={{ color: 'text.secondary' }} >
                {truncatedDescription}
            </DescTypography>
            <Box sx={{ width: '100%', height: '15%', mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <TagsTypography fontFamily={'sans-serif'} sx={{ justifyContent: 'left', }} >
                    {pubDate}
                </TagsTypography>
                <TagsTypography fontFamily={'sans-serif'} sx={{ justifyContent: 'right', }} >
                    {category}
                </TagsTypography>
            </Box>
        </Box>  
    </MainBox>
  )
}

export default NewsCard
